import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-319577a1"), n = n(), _popScopeId(), n);

const _hoisted_1 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_swipe_item = _resolveComponent("van-swipe-item");

  const _component_van_swipe = _resolveComponent("van-swipe");

  return _openBlock(), _createBlock(_component_van_swipe, {
    autoplay: 3000,
    "lazy-render": ""
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.state.images, image => {
      return _openBlock(), _createBlock(_component_van_swipe_item, {
        key: image
      }, {
        default: _withCtx(() => [_createElementVNode("img", {
          src: image.pic
        }, null, 8, _hoisted_1)]),
        _: 2
      }, 1024);
    }), 128))]),
    _: 1
  });
}